<ce-container>
    <ce-empty-state type="unauthorized" actionLabel="Go to login">
        <h1 ce-empty-state-title>Logging you in</h1>
        <p ce-empty-state-description>One moment redirecting you!</p>
    </ce-empty-state>
</ce-container>
